/* 🤖 this file was generated by svg-to-ts */
export const DfIconChevronDoubleRight16: {
  name: 'chevron-double-right-16';
  data: string;
} = {
  name: 'chevron-double-right-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M8.31 2.316a1.079 1.079 0 0 0 0 1.515l4.125 4.17-4.124 4.17a1.079 1.079 0 0 0 0 1.515 1.05 1.05 0 0 0 1.499 0l4.88-4.933a1.079 1.079 0 0 0 0-1.515L9.81 2.305a1.06 1.06 0 0 0-1.5.01zm-7 0a1.079 1.079 0 0 0 0 1.515l4.125 4.17-4.124 4.17a1.079 1.079 0 0 0 0 1.515 1.05 1.05 0 0 0 1.499 0l4.88-4.933a1.079 1.079 0 0 0 0-1.515L2.81 2.305a1.06 1.06 0 0 0-1.5.01z" fill-rule="evenodd"/></svg>`
};
